"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeRemoteLambda = exports.clearTokenCache = void 0;
var logging_1 = require("@augloop/logging/dist/src/client/logging");
var runtime_client_1 = require("@augloop/runtime-client");
var schemas_1 = require("@augloop/schemas/dist/src/client/schemas");
var tokenCache;
var clearTokenCache = function () {
    tokenCache = new runtime_client_1.TokenCache();
};
exports.clearTokenCache = clearTokenCache;
exports.clearTokenCache();
var executeRemoteLambdaWithRetries = function (url, message, inputSchema, outputSchema, correlationId, clientMetadata, hostCallbacks, retries, context, done) {
    var options = {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'X-CorrelationId': correlationId
        },
        body: JSON.stringify({
            payload: message.payload,
            payloadSchema: inputSchema,
            requestedSchema: outputSchema,
            clientMetadata: clientMetadata,
            tokens: tokenCache.getAuthTokenEntries(hostCallbacks, context.docId)
        })
    };
    runtime_client_1.internalFetch(url, options, function (error, response) {
        if (error) {
            done(new Error("Fetch error in remote lambda request to " + url + ": " + error));
        }
        else if (response.status === 401 /*UNAUTHORIZED*/) {
            if (retries > 0) {
                logging_1.Log.info(0x2224d0dd /* tag_8jnd3 */, logging_1.LogCategory.CoreDefault, 'Auth token required for remote lambda request');
                response
                    .json()
                    .then(function (ticket) {
                    return tokenCache.updateAuthToken(hostCallbacks, { Tickets: [ticket], DocId: context.docId });
                })
                    .then(function () {
                    executeRemoteLambdaWithRetries(url, message, inputSchema, outputSchema, correlationId, clientMetadata, hostCallbacks, retries - 1, context, done);
                })
                    .catch(function (err) {
                    // Missing or invalid ticket or token
                    done({
                        exceptionType: schemas_1.ExceptionType.Authentication,
                        message: err.message
                    });
                });
            }
            else {
                done({
                    exceptionType: schemas_1.ExceptionType.Authentication,
                    message: 'Remote lambda request retry with authentication token failed'
                });
            }
        }
        else if (!response.ok) {
            done(new Error("Remote lambda request failed with status " + response.status));
        }
        else {
            response.json()
                .then(function (outputs) {
                if (!Array.isArray(outputs)) {
                    done(new Error('Did not receive a valid response for remote lambda request'));
                }
                else if (outputs.length > 0) {
                    var currentIndex = 0;
                    for (var _i = 0, outputs_1 = outputs; _i < outputs_1.length; _i++) {
                        var output = outputs_1[_i];
                        message.moreResults = ++currentIndex < outputs.length;
                        done(null, output);
                    }
                }
                else {
                    done(new Error('No output'));
                }
            })
                .catch(function (err) {
                done({
                    exceptionType: schemas_1.ExceptionType.LambdaThrow,
                    message: err.message
                });
            });
        }
    });
};
var executeRemoteLambda = function (url, message, inputSchema, outputSchema, correlationVector, clientMetadata, hostCallbacks, context, done) {
    if (Array.isArray(context.authTickets)) {
        tokenCache
            .updateAuthToken(hostCallbacks, {
            Tickets: context.authTickets,
            DocId: context.docId
        })
            .then(function () {
            executeRemoteLambdaWithRetries(url, message, inputSchema, outputSchema, correlationVector.id, clientMetadata, hostCallbacks, 1, context, done);
        })
            .catch(function (err) {
            // Missing or invalid ticket or token
            done({
                exceptionType: schemas_1.ExceptionType.Authentication,
                message: err.message
            });
        });
    }
    else {
        executeRemoteLambdaWithRetries(url, message, inputSchema, outputSchema, correlationVector.id, clientMetadata, hostCallbacks, 1, context, done);
    }
};
exports.executeRemoteLambda = executeRemoteLambda;
//# sourceMappingURL=remote-lambda-http.js.map